import _ from 'lodash';
import imask from 'imask';
import cpf from 'cpf';
import cnpj from './cnpj';
import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';

export const CEP_REGEX = /^\d{5}-\d{3}?$/;
export const TELEFONE_REGEX = /\(\d{2}\)\s\d{4,5}-?\d{4}/;

// COMMONS
export const obrigatorio = (value, all, props) => {
	if (value === undefined) {
		return 'LABELS.VALIDACAO.CAMPO.OBRIGATORIO';
	}

	if (typeof value === 'object' && _.isEmpty(value)) {
		return 'LABELS.VALIDACAO.CAMPO.OBRIGATORIO';
	}

	if (typeof value !== 'object' && isEmpty(value.toString())) {
		return 'LABELS.VALIDACAO.CAMPO.OBRIGATORIO';
	}

	return undefined;
};

// CPF
const CPF_CONSTANT = '000.000.000-00';
const CPF_WITHOUT_MASK_LENGTH = 11;
const CPF_MASK = imask.createMask({ mask: CPF_CONSTANT });
// CNPJ
const CNPJ_CONSTANT = '00.000.000/0000-00';
// Os 12 primeiros caracteres da base do CNPJ sao alfanumericos (regra SERPRO);
// somente os 2 digitos verificadores finais permanecem numericos.
const CNPJ_MASK = imask.createMask({ mask: '**.***.***/****-00' });

export const formatCpf = (value, all, props) => {
	if (value === CPF_CONSTANT) {
		return value;
	}

	return CPF_MASK.resolve(value);
};

export const validateCpf = (value, all, props) => {
	if (value === CPF_CONSTANT) {
		return undefined;
	}

	if (cpf.isValid(value)) {
		return undefined;
	}

	return 'LABELS.VALIDACAO.CAMPO.CPF_INVALIDO';
};

export const validateCpfHasList = (value, all, props) => {
	const alluserLinked = props.getLinkedUser;
	if (alluserLinked.some(v => v.deIdentificacao === value)) {
		return `LABELS.COMMONS.MULTI.USUARIO.CPF.JA.ASSOCIADO`;
	}
	return undefined;
};

export const validateCnpjLogin = (value, all, props) => {
	if (value === CNPJ_CONSTANT) {
		return undefined;
	}

	if (cnpj.isValid(value)) {
		return undefined;
	}

	return 'LABELS.VALIDACAO.CAMPO.USUARIO.JURIDICO';
};

export const validateCnpj = (value, all, props) => {
	if (value === CNPJ_CONSTANT) {
		return undefined;
	}

	if (cnpj.isValid(value)) {
		return undefined;
	}

	return 'LABELS.VALIDACAO.CAMPO.CNPJ_INVALIDO';
};

export const formatCnpj = (value, all, props) => {
	if (value === CNPJ_CONSTANT) {
		return value;
	}

	return CNPJ_MASK.resolve(value);
};

export const validateCpfOuCnpj = (value, all, props) => {
	let error;
	const size = value.length || 0;
	const sizeCpf = CPF_CONSTANT.length;
	const sizeCnpj = CNPJ_CONSTANT.length;

	if (size !== sizeCpf && size !== sizeCnpj) {
		error = 'LABELS.VALIDACAO.CAMPO.CPF_CNPJ_INVALIDO';
	} else if (size === sizeCpf) {
		error = validateCpf(value, all, props);
	} else if (size === sizeCnpj) {
		error = validateCnpj(value, all, props);
	} else {
		error = undefined;
	}
	return error;
};

export const formatCpfOuCnpj = (value, all, props) => {
	const valueSemFormatacao = value.replace(/[./-]/g, '');
	const size = valueSemFormatacao.length || 0;
	const sizeCpf = CPF_WITHOUT_MASK_LENGTH;
	if (value === CPF_CONSTANT || value === CNPJ_CONSTANT) {
		return value;
	} else if (size <= sizeCpf) {
		return formatCpf(value);
	} else {
		return formatCnpj(value);
	}
};

// EMAIL
export const validateEmail = (value, all, props) => {
	if (isEmail(value)) {
		return undefined;
	}

	return 'LABELS.VALIDACAO.CAMPO.EMAIL_INVALIDO';
};

//SENHA
export const validateSenha = (value, all, props) => {
	if (value.includes(' ')) {
		return 'LABELS.VALIDACAO.CAMPO.SENHA_INVALIDO';
	}
	if (value.trim().length < 6) {
		return 'LABELS.VALIDACAO.CAMPO.SENHA_TAMANHO_MINIMO';
	}
};

// CEP
const CEP_MASK = imask.createMask({ mask: '00000-000' });

export const formatCep = value => {
	return CEP_MASK.resolve(value);
};

export const validateCep = value => {
	if (CEP_REGEX.test(value)) {
		return undefined;
	}

	return 'LABELS.VALIDACAO.CAMPO.CEP_INVALIDO';
};

// TELEFONE
const TELEFONE_MASK = imask.createMask({ mask: '(00) 0000-0000' });
const CELULAR_MASK = imask.createMask({ mask: '(00) 00000-0000' });
// imask aceita array de mask porem nao consegue efetuar o '.resolve'
// sempre valida com a primeira mask configurada
// criadas duas mask para validar o telefone

export const formatTelefone = value => {
	if (value.length > 14) {
		return CELULAR_MASK.resolve(value);
	}

	return TELEFONE_MASK.resolve(value);
};

export const validateTelefone = value => {
	if (value.length > 14) {
		if (TELEFONE_REGEX.test(value)) {
			return undefined;
		}

		return 'LABELS.VALIDACAO.CAMPO.TELEFONE_INVALIDO';
	}

	if (TELEFONE_REGEX.test(value)) {
		return undefined;
	}

	return 'LABELS.VALIDACAO.CAMPO.TELEFONE_INVALIDO';
};

// NUMERIC
export const numericLimit = (minValue, maxValue) => (value, previousValue) =>
	!isNaN(value) && value >= minValue && value <= maxValue ? value : previousValue;
